"use client";

import { useEffect } from "react";
import { Turnstile } from "@marsidev/react-turnstile";

type TurnstileChallengeProps = {
  action: string;
  onTokenChange: (token: string | null) => void;
};

export default function TurnstileChallenge({
  action,
  onTokenChange,
}: TurnstileChallengeProps) {
  const siteKey = process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY;
  const localPreview = process.env.NODE_ENV === "development" && process.env.NEXT_PUBLIC_ONBOARDING_PREVIEW === "1";

  useEffect(() => {
    if (localPreview) onTokenChange("local-preview-only");
  }, [localPreview, onTokenChange]);

  if (localPreview) return null;

  if (!siteKey) {
    return (
      <p className="text-sm text-red-200" role="alert">
        Human verification is unavailable. Please try again later.
      </p>
    );
  }

  return (
    <div className="min-h-0" data-testid={`turnstile-${action}`}>
      <Turnstile
        siteKey={siteKey}
        options={{
          action,
          appearance: "interaction-only",
        }}
        onSuccess={(token) => onTokenChange(token)}
        onExpire={() => onTokenChange(null)}
        onError={() => onTokenChange(null)}
      />
    </div>
  );
}
